var pug = require("!../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (partners) {pug_html = pug_html + (null == (pug_interp = require("./partials/office.pug").call(this, locals)) ? "" : pug_interp) + "\u003C!-- About Us Section--\u003E\u003Csection class=\"section-block scale-in\" id=\"about\"\u003E\u003C!-- Left Part--\u003E\u003Cdiv id=\"about-us-pattern\"\u003E\u003Cimg" + (pug.attr("src", require('../images/about-pattern.png'), true, true)+" alt=\"Cratfted-Pattern\"") + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"half-width\" id=\"about-us-logo\"\u003E\u003Cimg" + (pug.attr("src", require('../images/logo.png'), true, true)+" alt=\"Crafted Internet\"") + "\u003E\u003Ch2 class=\"heading hidden-md hidden-lg\"\u003E \u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C!-- \u002F Left Part--\u003E\u003C!-- Right Part--\u003E\u003Cdiv class=\"half-width\" id=\"about-us-text\"\u003E\u003Ch2 class=\"heading hidden-xs hidden-sm\"\u003EAbout  US\u003C\u002Fh2\u003E\u003Cdiv id=\"about-us-content\"\u003E\u003Cp\u003EWe are group of friends with different backgrounds, passionate about Internet market, love to build start ups that help people in their daily life and bring up ideas that make a difference\u003Cbr\u003EWe also love to share the experience we gained through our professional career, to support small business and help them to grow\u003Cbr\u003Ewe offer different services that help our customers take their businesses to the next level. From setting strategies, and creating brands to development and digital marketing. Our goal is to craft their success.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!-- \u002F Right Part--\u003E\u003C\u002Fsection\u003E\u003C!-- \u002F About Us Section--\u003E\u003C!-- Partners Section--\u003E\u003Csection class=\"section-block scale-in\" id=\"partners\"\u003E\u003Cimg" + (" id=\"partners-pattern\""+pug.attr("src", require('../images/about-pattern.png'), true, true)+" alt=\"\"") + "\u003E\u003C!-- Section Word--\u003E\u003Cdiv id=\"section-word\"\u003E\u003Cdiv class=\"triangle\"\u003E\u003C\u002Fdiv\u003E        “Our customers, our partners.\u003Cbr\u003EWe help them \u003Cspan class=\"colored bold\"\u003Ecraft\u003C\u002Fspan\u003E their success”\u003C\u002Fdiv\u003E\u003C!-- \u002F Section Word--\u003E\u003Cbr\u003E\u003C!-- Partners list--\u003E\u003Ch3 class=\"heading\" id=\"partners-heading\"\u003E\u003Cspan\u003EOur Partners\u003C\u002Fspan\u003E\u003C\u002Fh3\u003E\u003Cdiv id=\"partners-list\"\u003E\u003Cdiv class=\"partners-list-upper\"\u003E";
// iterate partners.data
;(function(){
  var $$obj = partners.data;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var partner = $$obj[index];
if (index < 7) {
if (partner) {
pug_html = pug_html + "\u003Cfigure class=\"partner\"\u003E";
if (partner.logo) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", partner.link, true, true)+" target=\"_blank\"") + "\u003E\u003Cimg" + (pug.attr("src", require(`../images/partners/${partner.logo}`), true, true)+pug.attr("alt", partner.alt, true, true)) + "\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Ffigure\u003E";
}
}
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var partner = $$obj[index];
if (index < 7) {
if (partner) {
pug_html = pug_html + "\u003Cfigure class=\"partner\"\u003E";
if (partner.logo) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", partner.link, true, true)+" target=\"_blank\"") + "\u003E\u003Cimg" + (pug.attr("src", require(`../images/partners/${partner.logo}`), true, true)+pug.attr("alt", partner.alt, true, true)) + "\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Ffigure\u003E";
}
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"partners-list-lower\" dir=\"rtl\"\u003E";
// iterate partners.data
;(function(){
  var $$obj = partners.data;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var partner = $$obj[index];
if (index >= 7) {
if (partner) {
pug_html = pug_html + "\u003Cfigure class=\"partner\"\u003E";
if (partner.logo) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", partner.link, true, true)+" target=\"_blank\"") + "\u003E\u003Cimg" + (pug.attr("src", require(`../images/partners/${partner.logo}`), true, true)+pug.attr("alt", partner.alt, true, true)) + "\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Ffigure\u003E";
}
}
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var partner = $$obj[index];
if (index >= 7) {
if (partner) {
pug_html = pug_html + "\u003Cfigure class=\"partner\"\u003E";
if (partner.logo) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", partner.link, true, true)+" target=\"_blank\"") + "\u003E\u003Cimg" + (pug.attr("src", require(`../images/partners/${partner.logo}`), true, true)+pug.attr("alt", partner.alt, true, true)) + "\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Ffigure\u003E";
}
}
    }
  }
}).call(this);

pug_html = pug_html + ("\u003C\u002Fdiv\u003E\u003C!-- \u002F Partners list--\u003E\u003C\u002Fdiv\u003E\u003C!-- \u002F Partners Section--\u003E\u003C\u002Fsection\u003E" + (null == (pug_interp = require("./partials/contact.pug").call(this, locals)) ? "" : pug_interp));}.call(this,"partners" in locals_for_with?locals_for_with.partners:typeof partners!=="undefined"?partners:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./pug/sections.pug
// module id = ./pug/sections.pug
// module chunks = 0